/* Rorilio · PDP Aceite Reafirmante de Noche : galerie, packs (quantité 1/3/5 sur la variante unique), compte à rebours, ATC collant, avis, timeline, ingrédients, avant/après, cercles. Aucun effet hors des éléments data-rac-*. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initGallery(root) {
    var track = root.querySelector('[data-rac-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-rac-thumb]');
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.racThumb, 10)); }); });
    var prev = root.querySelector('[data-rac-prev]'), next = root.querySelector('[data-rac-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
  }

  function initPacks(root) {
    var offer = root.querySelector('[data-rac-offer]');
    if (!offer || offer.dataset.ready) return;
    offer.dataset.ready = '1';
    var qty = root.querySelector('[data-rac-qty]');
    var sp = root.querySelector('[data-rac-sticky-price]');
    function select(card) {
      offer.querySelectorAll('[data-rac-pack]').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        var r = c.querySelector('input[type=radio]');
        if (r) r.checked = on;
      });
      if (qty) qty.value = card.dataset.qty || '1';
      if (sp) { var tpl = card.querySelector('[data-rac-pack-sticky]'); if (tpl) sp.innerHTML = tpl.innerHTML; }
    }
    offer.querySelectorAll('[data-rac-pack]').forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (r) r.addEventListener('change', function () { if (r.checked) select(card); });
    });
    var sel = offer.querySelector('[data-rac-pack].is-selected');
    if (sel) select(sel);
  }

  /* Compte à rebours : minuit heure de Mexico (America/Mexico_City = UTC-6 fixe, sans heure d'été depuis 2022), quel que soit le fuseau du visiteur ; repart chaque jour ; masqué après la fin de la promo (data-end, ISO). */
  var MX_OFFSET = 6 * 3600000;
  function nextMidnightMx(now) {
    var mx = new Date(now - MX_OFFSET);
    return Date.UTC(mx.getUTCFullYear(), mx.getUTCMonth(), mx.getUTCDate() + 1) + MX_OFFSET;
  }
  window.racNextMidnightMx = nextMidnightMx;
  function initCountdown(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var end = Date.parse(el.dataset.end || '');
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    var iv;
    function tick() {
      var now = Date.now();
      if (!isNaN(end) && now >= end) { el.hidden = true; el.style.display = 'none'; if (iv) clearInterval(iv); return; }
      var target = nextMidnightMx(now);
      if (!isNaN(end) && end < target) target = end;
      var left = Math.max(0, Math.floor((target - now) / 1000));
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
      if (s) s.textContent = pad(left % 60);
    }
    tick(); iv = setInterval(tick, 1000);
  }

  function initFixed(root) {
    var cd = root.querySelector('[data-rac-cd]');
    var st = root.querySelector('[data-rac-sticky]');
    var legend = root.querySelector('[data-rac-legend]');
    var atc = root.querySelector('[data-rac-atc]');
    if (cd) document.body.appendChild(cd);
    if (st) document.body.appendChild(st);
    function onScroll() {
      if (cd && legend) cd.classList.toggle('is-on', legend.getBoundingClientRect().top < 0);
      if (st && atc) { var r = atc.getBoundingClientRect(); st.classList.toggle('is-on', r.bottom < 0); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (st) {
      var b = st.querySelector('[data-rac-sticky-atc]');
      if (b && atc) b.addEventListener('click', function () { atc.click(); });
    }
  }

  function initScroller(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-rac-scroller-track]');
    if (!track) return;
    var items = track.children;
    function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
    function idx() { return Math.round(track.scrollLeft / Math.max(1, step())); }
    function go(i) { i = Math.max(0, Math.min(items.length - 1, i)); track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    var p = root.querySelector('[data-rac-scroller-prev]'), n = root.querySelector('[data-rac-scroller-next]');
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    root.querySelectorAll('[data-rac-more]').forEach(function (b) {
      b.addEventListener('click', function () { var c = b.closest('.rac-tm__card'); var o = c.classList.toggle('is-open'); b.textContent = o ? b.dataset.less : b.dataset.more; });
    });
  }

  function initTimeline(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = root.querySelectorAll('[data-rac-tab]'), panels = root.querySelectorAll('[data-rac-panel]');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      });
    });
  }

  function initIngredients(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-rac-ing-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = b.parentNode.querySelector('.rac-ing__desc');
        if (!d) return;
        d.hidden = !d.hidden;
        b.textContent = d.hidden ? b.dataset.more : b.dataset.less;
      });
    });
  }

  function initBA(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var r = root.querySelector('input[type=range]');
    if (r) r.addEventListener('input', function () { root.style.setProperty('--pos', r.value + '%'); });
  }

  function initCircles(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var items = root.querySelectorAll('[data-rac-circle]');
    function run() {
      items.forEach(function (it) {
        var target = parseInt(it.dataset.racCircle, 10) || 0;
        var fg = it.querySelector('.fg'), num = it.querySelector('[data-rac-num]');
        var c = 2 * Math.PI * 17;
        if (fg) { fg.style.strokeDasharray = c; fg.style.strokeDashoffset = c * (1 - target / 100); }
        var t0 = Date.now();
        var iv = setInterval(function () { var k = Math.min(1, (Date.now() - t0) / 1400); if (num) num.textContent = Math.round(target * k) + '%'; if (k >= 1) clearInterval(iv); }, 40);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { run(); io.disconnect(); } }, { threshold: .3 });
      io.observe(root);
    } else run();
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-rac-main]').forEach(function (root) { initGallery(root); initPacks(root); initFixed(root); });
    s.querySelectorAll('[data-rac-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-rac-countdown]').forEach(initCountdown);
    s.querySelectorAll('[data-rac-scroller]').forEach(initScroller);
    s.querySelectorAll('[data-rac-timeline]').forEach(initTimeline);
    s.querySelectorAll('[data-rac-ing]').forEach(initIngredients);
    s.querySelectorAll('[data-rac-ba]').forEach(initBA);
    s.querySelectorAll('[data-rac-circles]').forEach(initCircles);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
